import React, { memo } from 'react'
import Image from 'next/legacy/image'
import Link from 'next/link'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

// Iconos
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import YoutubeIcon from '@mui/icons-material/YouTube'
import XIcon from '@mui/icons-material/X'
import TiktokIcon from 'public/svg/tiktok.svg'

// Estilos
import sx from './styles'

const OnedayFooter = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  return (
    <Box
      sx={sx.root}
      component="footer"
      id="OnedayFooter"
    >
      <Container maxWidth="xl">
        <Grid
          container
          spacing={{ xs: 4, md: 2 }}
        >

          {/* ----- COLUMNA IZQUIERDA ----- */}
          <Grid
            size={{ xs: 12, md: 4 }}
            container
            spacing={3}
          >
            <Grid
              size={12}
              sx={sx.logoContainer}
            >
              <Image
                src="/oneday_assets/oneday_logos/oneday_logo_begativo.svg"
                alt="OneDay by ClikAuto"
                width={200}
                height={50}
                layout="responsive"
                objectFit="contain"
              />
            </Grid>

            <Grid size={12}>
              <Typography
                variant="inherit"
                sx={sx.titleText}
              >
                La forma más fácil, rápida y segura para vender o estrenar auto, sin salir de casa.
              </Typography>
            </Grid>

            {/* Iconos Sociales */}
            <Grid
              size={12}
              container
              spacing={2}
              alignItems="center"
            >
              <Grid size="auto">
                <a
                  href="https://www.facebook.com/ClikAuto"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FacebookIcon sx={sx.socialIcons} />
                </a>
              </Grid>
              <Grid size="auto">
                <a
                  href="https://www.linkedin.com/company/clikauto/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <LinkedInIcon sx={sx.socialIcons} />
                </a>
              </Grid>
              <Grid size="auto">
                <a
                  href="https://www.instagram.com/clikauto_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <InstagramIcon sx={sx.socialIcons} />
                </a>
              </Grid>
              <Grid size="auto">
                <a
                  href="https://www.youtube.com/@clikautofinance"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <YoutubeIcon sx={sx.socialIcons} />
                </a>
              </Grid>
              <Grid size="auto">
                <a
                  href="https://www.x.com/clikauto_"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X"
                >
                  <XIcon sx={sx.socialIcons} />
                </a>
              </Grid>
              <Grid size="auto">
                <a
                  href="https://www.tiktok.com/@clikauto"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TikTok"
                >
                  <TiktokIcon style={{ width: 24, height: 24, color: 'white' }} />
                </a>
              </Grid>
            </Grid>
          </Grid>

          {/* ----- DIVISOR CENTRAL ----- */}
          <Grid
            size={{ xs: 12, md: 1 }}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Divider
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                width: isMobile ? '100%' : '1px',
                height: isMobile ? '1px' : '80%',
                mt: isMobile ? 0 : 2,
              }}
              orientation={isMobile ? 'horizontal' : 'vertical'}
            />
          </Grid>

          {/* ----- COLUMNA DERECHA (Enlaces) ----- */}
          <Grid
            size={{ xs: 12, md: 7 }}
            container
            spacing={4}
            sx={{ pt: isMobile ? 2 : 3, alignContent: 'flex-start' }}
          >
            {/* <Grid size={{ xs: 12, sm: 'auto' }}>
              <Link
                href="/prensa"
                passHref
                legacyBehavior
              >
                <Typography
                  component="a"
                  variant="inherit"
                  sx={sx.linkText}
                >
                  Prensa
                </Typography>
              </Link>
            </Grid> */}
            <Grid size={{ xs: 12, sm: 'auto' }}>
              <Link
                href="/terminos-y-condiciones"
                passHref
                legacyBehavior
              >
                <Typography
                  component="a"
                  variant="inherit"
                  sx={sx.linkText}
                >
                  Términos y condiciones
                </Typography>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, sm: 'auto' }}>
              <Link
                href="/aviso-de-privacidad"
                passHref
                legacyBehavior
              >
                <Typography
                  component="a"
                  variant="inherit"
                  sx={sx.linkText}
                >
                  Aviso legal
                </Typography>
              </Link>
            </Grid>
            <Grid size={12}>
              <Typography
                variant="inherit"
                sx={sx.bodyText}
              >
                Pensado en México, creado desde distintos puntos del mundo; para todo el mundo.
              </Typography>
              <Typography
                variant="inherit"
                sx={sx.copyrightText}
              >
                © One Day by Clikauto
                {' '}
                {new Date().getFullYear()}
                {' '}
                Todos los derechos reservados
              </Typography>
            </Grid>
          </Grid>

        </Grid>
      </Container>
    </Box>
  )
}

export default memo(OnedayFooter)
